import { graphql } from "@/lib/gql/__generated__";

export const HotelArticleUpdate_DesignPage_Mutation = graphql(`
	mutation HotelArticleUpdate_DesignPage($input: HotelArticleInput!) {
		hotelArticleUpdate(input: $input) {
			userErrors
			hotel {
				id
				companyID
				hotelID
				inSale
				email
				tel
				name
				catchCopy
				customTypeRoomTitle
				facebookURL
				instagramURL
				twitterURL
				address {
					nationality
					postalCode
					state
					pref
					city
					town
					other
				}
				geoLocation {
					lat
					lon
				}
				logoImage {
					bucket
					key
					region
					mimeType
					fileName
				}
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				keyVisuals {
					bucket
					key
					region
					mimeType
					fileName
				}
				article {
					bucket
					key
					region
					mimeType
					fileName
				}
			}
		}
	}
`);
